'use strict';

module.exports = '3.33.0';



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/algoliasearch/src/version.js
// module id = 986
// module chunks = 0 1 2 3 4 5 6 7 8